import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// Importar páginas
import Portada from '@/pages/portada/'
import Ruta from '@/pages/ruta/unidad1'

export default new Router({
  routes: [
      {
        path: '/',
        name: 'portada',
        component: Portada
      },
      {
        path: '/ruta/:unipage',
        name: 'ruta',
        component: Ruta
      }
  ],
})

